export const MEDICAL_OFFICES_DEFAULT_FILTERS = {
	ASSISTANCE_TYPE: ['АПП', 'СТОМ'],
};
